module.exports = __webpack_public_path__ + "img/circle-cross-16.0c6808dd.svg";